import "./RateParityLeakageControl.module.css";
import Header from "@/reusable_sections/Header";
import Rateparityhero from "./sections/Rateparityhero";
import Rateleakageanalysis from "./sections/Rateleakageanalysis";
import RevenueStandards from "./sections/RevenueStandards";
import LeakageResolutionFramework from "./sections/LeakageResolutionFramework";
import Revenuegovernance from "./sections/Revenuegovernance";
import RateMonitoring from "./sections/RateMonitoring";
import Revenuefaq from "./sections/Revenuefaq";
import Services from "./sections/Services";
import Footer from "@/reusable_sections/Footer";
export default function RateParityLeakageControlPage() {
  return <div>
      <Header />
      <Rateparityhero />
      <Rateleakageanalysis />
      <RevenueStandards />
      <LeakageResolutionFramework />
      <Revenuegovernance />
      <RateMonitoring />
      <Revenuefaq />
      <Services />
      <Footer />
    </div>;
}